import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const AddRoleContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AddRoleProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("settings/roles", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <AddRoleContext.Provider value={contextValue}>
      {children}
    </AddRoleContext.Provider>
  );
};

export default AddRoleProvider;
